/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Image } from '@components/atoms'
import TabContext from '@mui/lab/TabContext'
import { MainNav } from './MainNav'
import { Drawer } from '../drawer/Drawer'
import { Toolbar } from '@mui/material'
import { Outlet } from 'react-router-dom'
import logoPng from '@public/images/logo/logo_grey.png'

import { useAppSelector } from '@redux/index'
import { useLocation } from 'react-router-dom'

export const MainLayout = (): JSX.Element => {
	// hook
	const location = useLocation()

	// redux state
	const selectedTabIdx: string = useAppSelector(state => state.config.selectedTabIdx)
	const drawerWidth: number = useAppSelector(state => state.config.drawerWidth)
	const isOpenDrawer: boolean = useAppSelector(state => state.config.isOpenDrawer)

	// variables
	const flexibleDrawerWidth: number = React.useMemo(
		() => (isOpenDrawer ? drawerWidth : 65),
		[isOpenDrawer],
	)
	const isImageContentView: boolean = ['/main/home', '/admin/home'].includes(
		location.pathname,
	)

	return (
		<View css={style}>
			<Drawer />

			<View
				className="mainLayoutInnerView"
				css={{ width: `calc(100% - ${drawerWidth}px)` }}
			>
				<View className="TabContaxtOuterView">
					<TabContext value={`Tab ${parseInt(selectedTabIdx)}`}>
						<MainNav
							style={
								isImageContentView
									? {
											height: 'calc(2.8rem - 1px)',
											marginBottom: '-1px',
											borderBottom: '0px',
									  }
									: {}
							}
						/>

						<View
							className={`container ${isImageContentView ? 'noPadding' : ''}`}
							css={{ width: `calc(100vw - ${flexibleDrawerWidth}px)` }}
						>
							<Toolbar className="toobar" />
							<View className="containerInnerView">
								<Outlet />
							</View>

							<Image
								src={logoPng}
								style={{
									position: 'absolute',
									width: '40rem',
									height: '40rem',
									zIndex: 0,
									top: '2.8rem',
									bottom: 0,
									margin: 'auto',
									right: 0,
									left: 0,
								}}
							/>
						</View>
					</TabContext>
				</View>
			</View>
		</View>
	)
}

const style = css({
	display: 'flex',
	position: 'relative',
	padding: 0,
	height: '100vh',
	width: '100%',

	'.mainLayoutInnerView': {
		display: 'flex',
		height: '100%',
		minHeight: '100%',

		'.TabContaxtOuterView': {
			position: 'relative',
		},

		'.toobar': {
			minHeight: '2.8rem',
		},

		'.container': {
			zIndex: 3,
			height: '100%',
			padding: '0.5rem',
			flexGrow: 1,
			overflow: 'hidden',

			'&.noPadding': {
				marginTop: '-1px',
				padding: 0,
			},
		},

		'.containerInnerView': {
			position: 'relative',
			zIndex: 3,
			width: '100%',
			minHeight: '100%',
		},
	},
})
